// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLScriptComponent__agentScriptHeader{color:#0461a1!important}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-common-react/MLScriptComponent/MLScriptComponent.module.scss"],"names":[],"mappings":"AAGA,2CACI,uBAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n@import '~ml-digital-theme-styles/sass/core';\n\n.agentScriptHeader {\n    color: $met-link-blue !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"agentScriptHeader": "app__MLScriptComponent__agentScriptHeader"
};
export default ___CSS_LOADER_EXPORT___;
